import React, { useState, useEffect } from 'react';
import { Platform } from 'react-native';

import { useTheme, Text, TextProps } from 'react-native-elements'; // rne-netzon replaced
import { colorPalette } from '../../../../core/config/color.config';

import {
  TextColor,
  TextVariants,
  TextWeight,
  TypeScale,
  TextAlign,
  getTypeScale,
} from './models';

interface RNETextProps extends TextProps {
  color?: TextColor;
  label: string;
  variant?: TextVariants;
  weight?: TextWeight;
  align?: TextAlign;
  style?: any;
}

// Set default values in the function signature
export const RNEText = ({
  label,
  color,
  style,
  align = 'left',
  variant = 'body',
  weight = '400',
  ...others
}: RNETextProps) => {
  const { theme } = useTheme();

  const [textColor, setTextColor] = useState<string | undefined>(theme.colors?.grey1);
  const [typeScale, setTypeScale] = useState<TypeScale | undefined>();

  const updateStyle = () => {
    switch (color) {
      case 'primary':
        setTextColor(theme.colors?.primary);
        break;

      case 'secondary':
        setTextColor(theme.colors?.secondary);
        break;

      case 'success':
        setTextColor(theme.colors?.success);
        break;

      case 'warning':
        setTextColor(theme.colors?.warning);
        break;

      case 'error':
        setTextColor(theme.colors?.error);
        break;

      case 'white':
        setTextColor(theme.colors?.white);
        break;

      case 'black':
        setTextColor(theme.colors?.black);
        break;

      case 'grey':
        setTextColor(theme.colors?.grey0);
        break;

      case 'accent':
        setTextColor(colorPalette.accent);
        break;

      case 'purple':
        setTextColor(colorPalette.purple);
        break;

      case 'tint':
        setTextColor(colorPalette.tint);
        break;

      default:
        setTextColor(color);
        break;
    }
  };

  const updateTypeScale = () => {
    const scale = getTypeScale(weight, variant, Platform.OS === 'web');
    setTypeScale(scale);
  };

  useEffect(() => {
    updateStyle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [color]);

  useEffect(() => {
    updateTypeScale();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [weight, variant]);

  return (
    <Text
      {...others}
      style={[
        {
          color: textColor,
          fontSize: typeScale?.size,
          fontFamily: typeScale?.family,
          fontWeight: typeScale?.weight,
          textAlign: align,
        },
        style, 
      ]}>
      {label}
    </Text>
  );
};
